import React from 'react';
import { ArrowLeft } from 'lucide-react';

export default function Impressum({ onClose }) {
  return (
    <div className="fixed inset-0 z-[60] bg-white overflow-y-auto" data-testid="impressum-page">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-100 py-4 px-4 sm:px-6 lg:px-8 z-10">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <button
            onClick={onClose}
            data-testid="impressum-back-button"
            className="flex items-center gap-2 text-[#2D5A27] hover:text-[#10B981] font-['Manrope'] font-medium text-sm transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück zur Startseite
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-[#1A3A22] tracking-tight mb-12">
          Impressum
        </h1>

        <div className="space-y-10 font-['Manrope'] text-gray-700 text-base leading-relaxed">
          {/* § 5 TMG */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p>K.H. und B. Daniels Elektroinstallationen GmbH</p>
            <p className="mt-3">Burbacher Straße 177<br />53129 Bonn</p>
            <p className="mt-3">Handelsregister: HRB 3672<br />Registergericht: Amtsgericht Bonn</p>
            <p className="mt-3"><strong className="text-[#1A3A22]">Vertreten durch:</strong> Frank Daniels</p>
          </section>

          {/* Kontakt */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Kontakt
            </h2>
            <p>Telefon: +49 228 23 46 44</p>
            <p>Fax: +49 228 446 99 59</p>
            <p>Mobil: +49 152 370 98 300</p>
            <p>E-Mail: info@daniels-gmbh.net</p>
          </section>

          {/* Berufsbezeichnung */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Berufsbezeichnung und besondere berufliche Regelungen
            </h2>
            <p>Berufsbezeichnung: Elektromeister, im Elektroinstallateur Handwerk</p>
            <p className="mt-2">Zuständige Kammer:</p>
            <p>Handwerkskammer zu Köln,<br />Heumarkt 12,<br />50667 Köln.<br />
              <a href="https://www.hwk-koeln.de" target="_blank" rel="noopener noreferrer" className="text-[#2D5A27] hover:text-[#10B981] underline transition-colors">
                www.hwk-koeln.de
              </a>
            </p>
          </section>

          {/* Verantwortlich */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p>Frank Daniels</p>
            <p className="mt-2">Burbacher Straße 177<br />53129 Bonn</p>
          </section>

          {/* Haftung für Inhalte */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Haftung für Inhalte
            </h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-3">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          {/* Haftung für Links */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Haftung für Links
            </h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
              verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mt-3">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
              einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
              Links umgehend entfernen.
            </p>
          </section>

          {/* Urheberrecht */}
          <section>
            <h2 className="font-['Outfit'] text-xl font-semibold text-[#1A3A22] mb-4">
              Urheberrecht
            </h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mt-3">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
              Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
              auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
              Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
